import {
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  UPDATE_PROFILE_SUCCESS
} from 'config/types';

const INITIAL_STATE = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  isLoading: true,
  user: null,
  errors: {},
};

export default function user(state=INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_USER:
    case USER_LOGIN:
      return {...state, isLoading: true};
    case LOAD_USER_SUCCESS:
    case USER_LOGIN_SUCCESS:
      localStorage.setItem('token', action.payload.token);
      return {...state, ...action.payload, isAuthenticated: true, isLoading: false, errors: null};
    case LOAD_USER_FAIL:
    case USER_LOGOUT:
    case USER_LOGIN_FAIL:
      localStorage.removeItem('token');
      return {...state, errors: action.payload, token: null, user: INITIAL_STATE.user, isAuthenticated: false, isLoading: false};
    case UPDATE_PROFILE_SUCCESS:
      return {...state, user: action.payload};
    default:
      return state;
  }
}
